export const reportDateTimeFormat = 'yyyy-MM-dd HH:mm';
export const datetimeInputFormat = "yyyy-MM-dd'T'HH:mm";

export const secReportComment = {
  'Звіт 2359': 'рейси, що отримали документи на виписці та не покинули територію, час затримки визначається фільтром',
  'Історія проходу ТЗ: розвантаження': 'рейси на розвантаження, що виїхали за територію у вибраний вами період дат',
  'Історія проходу ТЗ: завантаження': 'рейси на завантаження, що виїхали за територію у вибраний вами період дат',
  'Чорний список': 'cписок порушників',
};
